import React from 'react';
import { Box, BoxProps, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';
import IconFolder from 'shared/icons/iconFolder';
import CellContainer from 'shared/lib/extendedComponents/grids/components/cellContainer';
import { formatBackToFrontDate } from 'shared/lib/utils/globalUtils';
import { makeTransition } from 'shared/lib/utils/utils';
import { GridRowContext } from 'shared/lib/extendedComponents/grids/components/gridRowContainer';
import LimitedTypography from 'shared/lib/components/text/limitedTypography';
import { nbsp } from 'shared/lib/utils/uiConstants';
import { useTranslation } from 'react-i18next';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

const clamp = 1;

export default function MobileFolderNameCell({
  name,
  updatedAt,
  filesAmount,
  onClick,
  overrideColor,
}: {
  name: string;
  updatedAt: string;
  filesAmount: number;
  onClick?: () => void;
  overrideColor?: string;
} & BoxProps) {
  const { t } = useTranslation();
  const str = t('file.filecount', { count: filesAmount });

  const { sp } = defaultSpacingPresets;
  const theme = useTheme();
  const { isHover } = useContext(GridRowContext);

  const color = isHover
    ? theme.palette.primary.main
    : overrideColor || theme.palette.text.primary;

  return (
    <CellContainer onClick={onClick}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: sp.s30,
          overflow: 'hidden',
        }}
      >
        <Box sx={{ flexShrink: 0 }}>
          <IconFolder sizeKey="48x48"></IconFolder>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: sp.s20,
          }}
        >
          <LimitedTypography
            clamp={clamp}
            sx={{
              fontSize: '18px !important',
              fontWeight: 700,
              color,
              transition: makeTransition(['color']),
            }}
          >
            {name}
          </LimitedTypography>

          <Typography sx={{ display: 'inline-flex' }}>
            <Typography
              sx={{ fontSize: '14px !important' }}
              color="text.secondary"
            >{`Изменено: ${formatBackToFrontDate(updatedAt)}`}</Typography>
          </Typography>
        </Box>
      </Box>
    </CellContainer>
  );
}
